// Home Analytics Factory - Dependency Injection

import {HomeAnalyticsRepositoryImpl} from '../repository/HomeAnalyticsRepositoryImpl';
import {GetInventoryProductsAnalyticsUseCase} from '../useCases/GetInventoryProductsAnalyticsUseCase';
import {GetVisitsAnalyticsUseCase} from '../useCases/GetVisitsAnalyticsUseCase';
import {GetStoresUsersAnalyticsUseCase} from '../useCases/GetStoresUsersAnalyticsUseCase';

// Factory class for the Home Analytics feature
export class HomeAnalyticsFactory {
  private static repository: HomeAnalyticsRepositoryImpl | null = null;

  // Repository Singleton
  private static getRepository (): HomeAnalyticsRepositoryImpl {
    if (!this.repository) {
      this.repository = new HomeAnalyticsRepositoryImpl();
    }
    return this.repository;
  }

  // Use Cases Factory Methods
  static createGetInventoryProductsAnalyticsUseCase (): GetInventoryProductsAnalyticsUseCase {
    return new GetInventoryProductsAnalyticsUseCase(this.getRepository());
  }

  static createGetVisitsAnalyticsUseCase (): GetVisitsAnalyticsUseCase {
    return new GetVisitsAnalyticsUseCase(this.getRepository());
  }

  static createGetStoresUsersAnalyticsUseCase (): GetStoresUsersAnalyticsUseCase {
    return new GetStoresUsersAnalyticsUseCase(this.getRepository());
  }

  // Reset factory (useful for testing)
  static reset (): void {
    this.repository = null;
  }
}
